export interface UpdateGridHeadersRequest {
  id: string;
  displayName: string;
  isShown: boolean;
  isFilterable: boolean;
  isSortable: boolean;
  displayOrder: number;
}
